enum GeospatialMapLayerType {
  XyzTiles = "XyzTiles",
}

export default GeospatialMapLayerType;
